// @flow

import { TweenMax } from 'gsap';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled, { type StyledComponent } from 'styled-components';

import type { RootState } from '../../../store/types';

type ProgressBarRawProps = {
  className?: string,
};

const ProgressBarRaw = ({ className }: ProgressBarRawProps) => {
  const nbTotalSteps1 = 7;
  const nbTotalSteps2 = 3;
  const common = useSelector((state: RootState) => state.common);

  useEffect(() => {
    let progressTo = Math.round((100 / nbTotalSteps1) * common.step);
    if (common.step >= 8) {
      progressTo = Math.round((100 / nbTotalSteps2) * (common.step - 7));
    }
    TweenMax.to('.progressBar-progress', 1, { width: `${progressTo}%` });
  }, [common.step]);

  return (
    <div className={className}>
      <div className={'progressBar-progress'} />
    </div>
  );
};

export const ProgressBar: StyledComponent<
  ProgressBarRawProps,
  {},
  typeof ProgressBarRaw
> = styled(ProgressBarRaw)`
  top: 0;
  width: 100%;
  height: 8px;
  background-color: rgba(255, 197, 20, 0.4);
  margin: 0 auto;

  .progressBar-progress {
    background-color: #ffc514;
    height: 100%;
  }
`;
